import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { renewals } from "@/api/endpoints";
import { Spinner } from "@/components/shared/Spinner";
import { Money } from "@/components/shared/Money";

export function RenewalQueue() {
  const [withinDays, setWithinDays] = useState(60);
  const q = useQuery({
    queryKey: ["renewals", withinDays],
    queryFn: () => renewals.list(withinDays),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold">Renewal queue</h1>
        <label className="flex items-center gap-2 text-sm text-slate-500">
          <span>Window (days)</span>
          <input
            type="number"
            min={1}
            max={3650}
            value={withinDays}
            onChange={(e) => setWithinDays(Number(e.target.value || 60))}
            className="w-20 rounded-md border border-slate-300 px-2 py-1 dark:bg-slate-800 dark:border-slate-700"
          />
        </label>
      </div>

      {q.isLoading ? (
        <Spinner />
      ) : q.error ? (
        <div className="text-red-700">{(q.error as Error).message}</div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-200 bg-white dark:bg-slate-900 dark:border-slate-800">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 dark:bg-slate-800/50 dark:text-slate-300">
              <tr>
                <th className="px-3 py-2 text-left">Customer</th>
                <th className="px-3 py-2 text-left">Status</th>
                <th className="px-3 py-2 text-left">End date</th>
                <th className="px-3 py-2 text-right">Days remaining</th>
                <th className="px-3 py-2 text-right">Devices</th>
                <th className="px-3 py-2 text-right">30d revenue</th>
              </tr>
            </thead>
            <tbody>
              {(q.data ?? []).length === 0 && (
                <tr>
                  <td colSpan={6} className="px-3 py-6 text-center text-slate-400">
                    Nothing in the queue.
                  </td>
                </tr>
              )}
              {(q.data ?? []).map((r) => (
                <tr
                  key={r.contract_id}
                  className="border-t border-slate-100 dark:border-slate-800"
                >
                  <td className="px-3 py-2 font-medium">
                    <Link to={`/contracts/${r.contract_id}`} className="hover:underline">
                      {r.customer_name}
                    </Link>
                  </td>
                  <td className="px-3 py-2">{r.status}</td>
                  <td className="px-3 py-2">{r.end_date}</td>
                  <td
                    className={`px-3 py-2 text-right ${r.days_remaining < 0 ? "text-red-600" : r.days_remaining <= 14 ? "text-amber-600" : ""}`}
                  >
                    {r.days_remaining}
                  </td>
                  <td className="px-3 py-2 text-right">{r.devices.length}</td>
                  <td className="px-3 py-2 text-right">
                    <Money value={r.total_trailing_30d_revenue} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
